import { ColumnConfig, ColumnDataType } from '@aurora';

export const messageColumnsConfig: ColumnConfig[] = [
    {
        type: ColumnDataType.STRING,
        field: 'conversation.name',
        searchableField: '$conversation.name$',
        sort: 'conversation.name',
        translation: 'Name',
        isUnaccent: true,
    },
    {
        type: ColumnDataType.ENUM,
        field: 'role',
        sort: 'role',
        translation: 'chat.Role',
    },
    {
        type: ColumnDataType.STRING,
        field: 'message',
        sort: 'message',
        translation: 'chat.Message',
        isUnaccent: true,
    },
];
